import React from "react";

const NewOrderSoundAlert = () => (
  <audio loop src={process.env.PUBLIC_URL + "/OrderAlert.mp3"} autoPlay />
);

export default NewOrderSoundAlert;
